import { BaseModel } from "./BaseModel";

export class LCGroup extends BaseModel {
  schema = "/lcgroup";
  constructor(params) {
    return super(params, "/lcgroup");
  }
}
